module.exports = __webpack_public_path__ + "img/stock3.c40b57a3.png";